export default __webpack_public_path__ + "static/media/black-friday-off.7557a7b2.svg";